import { Box } from "@mui/material";
import { useTheme } from "@mui/material";
import GeographyChart from "../../../../components/GeographyChart";
import { tokens } from "../../../../theme";
import DashboardLayout from "../../../../components/global/DashboardLayout";
import DashboardHeader from "../../../../components/global/DashboardHeader";

const Geography = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <DashboardLayout>
      <Box m="20px">
        <DashboardHeader title="Geography Chart" subtitle="Simple Geography Chart" />
        <Box
          height="70vh"
          border={`1px solid ${colors.grey[100]}`}
          borderRadius="4px"
        >
          <GeographyChart />
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default Geography;
